import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const LanguageSelectorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 8px;
  width: 164px;
  background: #FFFFFF;
  position: relative;
  cursor: pointer;
  user-select: none;
`

export const SelectedValue = styled.span`
  ${({ theme }) => css(theme.typographys.small.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
  flex: 1;
`

export const DropdownList = styled.ul<{ isOpen: boolean }>`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  bottom: calc(100% + 4px);
  left: 0;
  z-index: 100;

  [dir="rtl"] & {
    left: auto;
    right: 0;
  }
  background: ${({ theme }) => theme.colors.neutrals.w};
  border: 1px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: 8px;
  padding: 4px 0;
  margin: 0;
  list-style: none;
  min-width: 160px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`

export const DropdownItem = styled.li<{ isSelected: boolean }>`
  padding: 8px 12px;
  cursor: pointer;
  ${({ theme }) => css(theme.typographys.small.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
  background: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.grey[1] : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.colors.grey[1]};
  }
`

export const MobileOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: ${({ theme }) => theme.colors.neutrals.w};
  display: flex;
  flex-direction: column;
`

export const MobileOverlayHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.grey[1]};
  position: relative;
`

export const MobileCloseButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;

  [dir="rtl"] & {
    right: auto;
    left: 16px;
  }
  transform: translateY(-50%);
  background: ${({ theme }) => theme.colors.grey[2]};
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: ${({ theme }) => theme.colors.neutrals.b};
`

export const MobileSearchInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[2]};
  ${({ theme }) => css(theme.typographys.small.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
  outline: none;
  background: ${({ theme }) => theme.colors.neutrals.w};

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey[4]};
  }
`

export const MobileLanguageList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  overflow-y: auto;
  flex: 1;
`

export const MobileLanguageItem = styled.li<{ isSelected: boolean }>`
  padding: 16px;
  cursor: pointer;
  ${({ theme }) => css(theme.typographys.base.regular)}
  color: ${({ theme }) => theme.colors.neutrals.b};
  background: ${({ theme, isSelected }) =>
    isSelected ? theme.colors.grey[1] : 'transparent'};

  &:hover {
    background: ${({ theme }) => theme.colors.grey[1]};
  }
`
